import React, {Component} from 'react';
import {connect} from "react-redux";
import CircularProgress from "@material-ui/core/CircularProgress";
import Table from "../../../../components/Table";
import BranchAdd from "./add";
import Swal from "sweetalert2";
import {makeRequest} from "../../../../helpers/network_utils";
import {DELETE_REQUEST} from "../../../../values/globals";
import endpoints from "../../../../routes/endpoints";
import {parseErrorResponse, showAlert} from "../../../../helpers/helper_functions";
import {getBranches} from "../../../../redux/branch/actions";

const $ = window.$;

const mapStateToProps = state => (state.branchesState);

const mapDispatchToProps = dispatch => ({
    getBranches: () => dispatch(getBranches()),
});
let self;
const columns = [
    {
        dataField: 'id',
        text: 'ID',
        //  formatter: row => `${row.first_name} ${row.last_name}`
    },
    {
        dataField: 'name',
        text: 'Name',
        //  formatter: row => `${row.first_name} ${row.last_name}`
    },
    {
        dataField: 'code',
        text: 'Code',
        //  formatter: row => `${row.first_name} ${row.last_name}`
    },
    {
        dataField: 'iddd',
        text: 'Action',
        formatter: (id, row) => <button onClick={() => self.handleEditBranch(row)}
                                        className="btn btn-sm btn-primary">
            Edit
        </button>

    },
    {
        dataField: 'idd',
        text: 'Action',
        formatter: (id, row) => <button disabled={self.state.loadingDelete}
                                        onClick={() => self.handleDeleteBranch(row.id)}
                                        className="btn btn-sm btn-danger">
            {self.state.loadingDelete ? "Loading" : "Delete"}
        </button>

    },
]


class Branches extends Component {
    state = {};

    componentDidMount() {
        self = this;
        const {getBranches, branches} = this.props;
        if (branches == null) getBranches();
    }

    handleAddBranch = e => {
        e.preventDefault();
        this.setState({
            branch: null
        }, () => $('#addBranchModal').modal('show'));
    }

    handleEditBranch = (branch) => {
        this.setState({
            branch: branch
        }, () => $('#addBranchModal').modal('show'));

    }

    handleDeleteBranch = (id) => {
        Swal.fire({
            title: "Confirm Delete",
            text: `Are you sure you want to delete this center?`,
            icon: "info",
            showConfirmButton: true,
            showCancelButton: true
        }).then(result => {
            if (result.isConfirmed) {

                this.setState({
                    loadingDelete: true
                })
                makeRequest(DELETE_REQUEST, `${endpoints.branches}${id}/`, {}, () => {
                    Swal.fire(
                        'Success!',
                        `Center was deleted successfully!`,
                        'success'
                    ).then(() => {
                        this.props.getBranches();
                    });
                }, (error) => {
                    showAlert('error', 'Error', parseErrorResponse(error));
                }, () => {
                    this.setState({loadingDelete: false})
                }).then()
            }
        })
    }

    render() {
        const {loading, branches,} = this.props;
        const {branch} = this.state;
        return (loading ?
                <div className="text-center">
                    <CircularProgress/>
                </div> :
                <div>
                    <BranchAdd branch={branch} key={Math.random()}
                               getBranches={this.props.getBranches}/>
                    <Table
                        caption={"Centers"}
                        actionText={"Add Center"}
                        columns={columns}
                        actionFunc={this.handleAddBranch}
                        data={branches}
                    />
                </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Branches);